export default "__VITE_ASSET__Dzvl8ONN__"